import { Link, NavLink, Outlet } from 'react-router-dom';
import { useSession } from './lib/session.js';

export default function App() {
  const { me } = useSession();

  return (
    <div className="app">
      <header className="site-header">
        <Link to="/" className="brand" aria-label="2x3skimmer home">
          <span className="brand-mark" aria-hidden="true">
            <span className="dit" />
            <span className="dah" />
          </span>
          <span className="brand-name">2x3skimmer</span>
          <span className="brand-tag">copy desk</span>
        </Link>

        <nav>
          <NavLink to="/clips">Clips</NavLink>
          <NavLink to="/guide">How to copy</NavLink>
          {me?.admin && <NavLink to="/admin">Invites</NavLink>}
        </nav>

        {me && (
          <NavLink to="/join" className="me-chip" title="Your invite and settings">
            {me.callsign}
          </NavLink>
        )}
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="site-footer">
        <span>
          2x3skimmer &middot; a multi-signal CW skimmer in the making at WB5SKM
        </span>
        <span className="muted">
          Audio recorded off the air. Your QSO in here? <Link to="/guide">See the guide</Link> to have it taken down.
        </span>
      </footer>
    </div>
  );
}
